import { QueryClient } from '@tanstack/react-query';

/**
 * The app's one query cache, kept in its own module so the auth provider can
 * empty it when the signed-in account changes.
 *
 * Query keys carry the company and filters but never the user, while the API
 * answers the same request differently per account (a scoped user sees fewer
 * companies, and payroll comes back as a single total without payroll access).
 * A cache that outlived the session could show the next account the last one's
 * data until it went stale.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // A 401 is handled by the client's refresh logic and a 403 will never
      // succeed on retry, so neither is worth repeating.
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
    },
  },
});
